/**
 * 가로 화면의 90도 돌림 수학. 렌더러(`renderer.ts`)와 입력(`game/input.ts`)이 같이 쓰고, 시험이 픽시 없이
 * 왕복을 못 박는다(리뷰가 권했다).
 *
 * 가로 화면이면 카메라가 월드를 +90도(픽시에서 시계 방향) 돌려 보인다: 월드 (x, y) → 화면 (-y, x).
 * 그래서 월드의 위(-y, 적 쪽)가 화면의 오른쪽, 월드의 왼쪽(-x)이 화면의 위다. 시뮬레이션은 늘 "위로 진격"이다.
 */

/** 월드 픽셀 → 화면 픽셀. (camX, camY)는 카메라 컨테이너의 자리(화면 픽셀), zoom은 배율. */
export function worldToScreen(
  rotated: boolean,
  camX: number,
  camY: number,
  zoom: number,
  x: number,
  y: number,
  out: { x: number; y: number },
): void {
  if (rotated) {
    out.x = camX - y * zoom;
    out.y = camY + x * zoom;
  } else {
    out.x = camX + x * zoom;
    out.y = camY + y * zoom;
  }
}

/** `worldToScreen`의 역. */
export function screenToWorld(
  rotated: boolean,
  camX: number,
  camY: number,
  zoom: number,
  sx: number,
  sy: number,
): { x: number; y: number } {
  if (rotated) return { x: (sy - camY) / zoom, y: (camX - sx) / zoom };
  return { x: (sx - camX) / zoom, y: (sy - camY) / zoom };
}

/**
 * 월드 사각형(왼쪽 위 viewX, viewY, 월드 높이 viewH)이 화면을 꼭 채우도록 카메라 컨테이너를 둘 자리.
 * 가로면 월드 x(viewX…)가 화면 위→아래, 월드 y(viewY…viewY+viewH)가 화면 오른쪽→왼쪽이다.
 */
export function cameraOrigin(
  rotated: boolean,
  viewX: number,
  viewY: number,
  viewH: number,
  zoom: number,
): { x: number; y: number } {
  if (rotated) return { x: (viewY + viewH) * zoom, y: -viewX * zoom };
  return { x: -viewX * zoom, y: -viewY * zoom };
}

/**
 * 화면에서 잰 방향(조이스틱·키·끄는 손가락) → 월드 방향. 가로면 화면 (x, y) → 월드 (y, -x).
 * `0 - x`로 쓴다: -0이 커맨드 로그에 실리지 않게(0 - 0은 +0).
 */
export function screenDirToWorld(rotated: boolean, x: number, y: number): [number, number] {
  return rotated ? [y, 0 - x] : [x, y];
}
